import { useState } from 'react';
import useUiConfig from 'app/hooks/useUiConfig';
import { useToast } from 'app/context/ToastContext';
import FeedbackDrawer from 'app/modules/virtual-assistant/components/chat-items/FeedbackDrawer';
import { FeedbackSentiment, FeedbackType, UserQueryType } from 'app/hooks/fetch/useFeedbackAnalytics';
import TailorSearchFeedbackBanner from 'app/modules/tailor/components/TailorSearchFeedbackBanner';

interface SearchFeedbackProps {
  searchQuery: string;
}

export default function SearchFeedback({ searchQuery }: SearchFeedbackProps) {
  const uiConfig = useUiConfig();
  const { showToast } = useToast();
  const [isFeedbackDrawerOpen, setIsFeedbackDrawerOpen] = useState(false);

  const thankYouMessage = uiConfig?.feedback?.faqThankYouMessage;

  const showFeedbackToast = (message?: string) => {
    if (message) {
      showToast(message);
    }
  };

  const closeFeedbackDrawer = () => {
    setIsFeedbackDrawerOpen(false);
    showFeedbackToast(thankYouMessage);
  };

  const handleFeedback = (feedbackSentiment: FeedbackSentiment) => {
    if (feedbackSentiment === FeedbackSentiment.POSITIVE) {
      showFeedbackToast(thankYouMessage);
    } else {
      setIsFeedbackDrawerOpen(true);
    }
  };

  return (
    <>
      <TailorSearchFeedbackBanner
        searchQuery={searchQuery}
        onFeedback={handleFeedback}
      />
      <FeedbackDrawer
        isOpen={isFeedbackDrawerOpen}
        onClose={closeFeedbackDrawer}
        userQuery={searchQuery}
        userQueryType={UserQueryType.Search}
        resultType="faq"
        feedbackType={FeedbackType.Search}
        secondaryFeedbackOptions={uiConfig?.feedback?.faqSecondaryFeedbackOptions || []}
        secondaryFeedbackHeader={uiConfig?.feedback?.faqSecondaryFeedbackHeader || ''}
        otherFieldEnabled={uiConfig?.feedback?.faqOtherFieldEnabled || false}
      />
    </>
  );
}
